import React from "react";
import { Input, InputGeofenceStatus } from "../../../Helpers/Input/Input";
import { useSelector } from "react-redux";
import trans from "../../../../utils";

export default function GeofenceBody({ AddGeo }) {
  let inf = useSelector((state) => state.users.user);
  return (
    <div className="p-16">
      <Input
        formstyle="w-100 mb-2"
        title={trans("Name")}
        type="text"
        placeholder={trans("Geofence Name")}
        id="name"
        name="name"
        onBlur={AddGeo.handleBlur}
        onChange={AddGeo.handleChange}
        errors={AddGeo.errors.name}
        touched={AddGeo.touched.name}
        value={AddGeo.values.name || ""}
      />
      <Input
        formstyle="w-100 mb-2"
        title={trans("Description")}
        type="text"
        placeholder={trans("Geofence Description")}
        id="description"
        name="description"
        onBlur={AddGeo.handleBlur}
        onChange={AddGeo.handleChange}
        value={AddGeo.values.description || ""}
      />

      <InputGeofenceStatus
        formstyle="w-100 mb-2"
        title={trans("Color")}
        type="color"
        id="attributes.color"
        name="attributes.color"
        onBlur={() => AddGeo.setFieldTouched("attributes.color", true)}
        onChange={(value) =>
          AddGeo.setFieldValue("attributes.color", value ? value : "")
        }
        value={AddGeo.values.attributes?.color || ""}
        errors={AddGeo.errors.attributes?.color}
        touched={AddGeo.touched.attributes?.color}
      />
      <Input
        formstyle="w-100 mb-2"
        title={`${trans("Speed Limit")} (${
          inf.attributes.speedUnit
            ? trans(inf.attributes.speedUnit)
            : trans("kn")
        })`}
        type="text"
        placeholder={trans("Set Speed Limit")}
        id="attributes.speedLimit"
        name="attributes.speedLimit"
        onBlur={AddGeo.handleBlur}
        onChange={AddGeo.handleChange}
        errors={AddGeo.errors.attributes?.speedLimit}
        touched={AddGeo.touched.attributes?.speedLimit}
        value={AddGeo.values.attributes.speedLimit || ""}
      />
    </div>
  );
}
